(function () {
  'use strict';

  /* === Loading Bar === */
  var bar = document.getElementById('vm-loading-bar');

  function startLoading() {
    if (!bar) return;
    bar.style.width = '70%';
    bar.style.opacity = '1';
  }

  function finishLoading() {
    if (!bar) return;
    bar.style.width = '100%';
    setTimeout(function () {
      bar.style.opacity = '0';
      setTimeout(function () {
        bar.style.width = '0%';
        bar.style.opacity = '1';
      }, 400);
    }, 300);
  }

  window.addEventListener('beforeunload', startLoading);
  window.addEventListener('load', finishLoading);
  window.addEventListener('pageshow', finishLoading);

  /* === Header inteligente al scroll === */
  var headerGroup = document.getElementById('header-group');
  var lastScrollY = window.scrollY;
  var scrollThreshold = 80;
  var ticking = false;

  function handleScroll() {
    var currentScrollY = window.scrollY;
    if (!ticking) {
      window.requestAnimationFrame(function () {
        if (currentScrollY > scrollThreshold) {
          if (currentScrollY > lastScrollY) {
            headerGroup && headerGroup.classList.add('vm-header--hidden');
          } else {
            headerGroup && headerGroup.classList.remove('vm-header--hidden');
          }
          headerGroup && headerGroup.classList.add('vm-header--scrolled');
        } else {
          headerGroup && headerGroup.classList.remove('vm-header--hidden');
          headerGroup && headerGroup.classList.remove('vm-header--scrolled');
        }
        lastScrollY = currentScrollY;
        ticking = false;
      });
      ticking = true;
    }
  }

  window.addEventListener('scroll', handleScroll, { passive: true });

  /* === IntersectionObserver para fade-up === */
  if (!('IntersectionObserver' in window)) return;

  var revealOptions = {
    threshold: 0.12,
    rootMargin: '0px 0px -40px 0px'
  };

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, revealOptions);

  function observeRevealElements() {
    document.querySelectorAll('.vm-reveal, .vm-reveal-group').forEach(function (el) {
      observer.observe(el);
    });
  }

  observeRevealElements();
  document.addEventListener('shopify:section:load', observeRevealElements);
})();
